module.exports = __webpack_public_path__ + "img/img-navegacion-app.6688be60.png";